import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const getDriveJobRoles = createAsyncThunk('getDriveJobRoles', async (driveId, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/drive/job-roles?driveId=${driveId}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const driveJobRoles = createSlice({
    name: 'driveJobRoles',
    initialState: {
        loading: false,
        error: null,
        jobRoles: []
    },
    extraReducers: (builder) => {
        builder.addCase(getDriveJobRoles.pending, (state, action) => {
            state.loading = true;
            state.jobRoles = []
        })
        builder.addCase(getDriveJobRoles.fulfilled, (state, action) => {
            state.loading = false;
            state.jobRoles = action.payload
        })
        builder.addCase(getDriveJobRoles.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.response.data.message
        })
    }
})

export default driveJobRoles.reducer